<template>
<div>
  <pt-lab-samples-received-form ref="form" class="pt-lab-samples-received-form__withData" v-model="statusForm"></pt-lab-samples-received-form>
  <show-handle-result-dialog @updateVisible="updateVisible" :dialogVisible="showDialog" :isShowReason="isShowReason" :table-data="gridData" status="样本接收">
    </show-handle-result-dialog>
</div>
</template>

<script>
import showHandleResultDialog from 'cps/lab-order/show-handle-result-dialog'
import PtLabSamplesReceivedForm from './index'
import { handleData } from 'cps/lab-order/show-handle-result-dialog/handle-options'
export default {
  name: 'pt-lab-samples-received-form__withData',
  components: {
    'pt-lab-samples-received-form': PtLabSamplesReceivedForm,
    showHandleResultDialog
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isShowReason () {
      return this.statusForm.result !== 'QUALIFIED'
    }
  },
  // methods: {
  //   submit () {
  //     this.form.validate().then(formValue => {
  //       this.$store.dispatch('').then(data => {
  //         // doing something ...
  //       }).catch(errorMessage => {
  //         console.error(errorMessage)
  //         this.$toast.error(errorMessage)
  //       })
  //     })
  //   }
  // }
  data () {
    return {
      statusForm: {
        result: 'QUALIFIED',
        reason: ''
      },
      showDialog: false,
      gridData: []
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
      if (!val) {
        // 更新表格数据
        this.$emit('updateTable', true)
        // 更新待处理订单数量，如若接口会返回该数据的话则不用
        this.$emit('updateAllSize', true)
      }
    },
    formValidate () {
      return this.form.validate()
    },
    async submit (orderIds, list) {
      // 传入表单和文件
      // this.$refs.qualityFile.submit()
      let data = {}
      data = { orderIds: orderIds, action: 'LAB_SAMPLES_RECEIVED' }
      data.orderStatusDetail = {
        orderStatusResult: this.statusForm.result,
        comment: this.statusForm.comment
      }
      if (this.statusForm.result === 'NOT_QUALIFIED_WAIT_FUTURE_ACTION') {
        data.orderStatusDetail.reason = this.statusForm.reason
      } else {
        let correctData = list.every(item => {
          if (!item.labCode) {
            throw (new Error('请检查样本条码为:' + item.sampleId + '的样本是否填写生产条码号！'))
          } else {
            return true
          }
        })
        if (correctData) {
          let labCodes = list.map(e => {
            return {
              orderId: e.id,
              labCode: e.labCode
            }
          })
          data.labCodes = labCodes
        }
      }
      return this.$store.dispatch('AdultOrderStatusUpdate', data)
    },
    resetForm () {
      this.statusForm = {
        result: 'QUALIFIED',
        reason: '',
        comment: ''
      }
    },
    submitForm (memberIds, list = []) {
      this.submit(memberIds, list).then(response => {
        this.$emit('getResult', response)
        this.resetForm()
        this.showDialog = true
        this.gridData = handleData(response.data)
      }).catch(err => {
        // 单纯的前端错误信息
        if (err.message) {
          this.$emit('onlyUpdateLoading', false)
        } else {
          this.$emit('updateLoading', false)
          this.$emit('getResult')
        }
        this.$message.error(err.message || err || '操作失败！')
      })
    }
  }
}
</script>
